<div class="modal-container">
    <h2 mat-dialog-title>{{'selectPrintLabelView.printShippingLabels' | translate}}</h2>

    <mat-dialog-content>
        <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">

            <mat-form-field fxLayout="column" fxLayoutAlign="stretch">
                <mat-label>{{'selectPrintLabelView.shippingLabelLabel' | translate}}</mat-label>
                <mat-select [formControlName]="'selectedShippingLabel'">
                    <mat-option *ngIf="!shippingLabels?.length" [value]="null" disabled>
                        {{'selectPrintLabelView.noShippingLabelsAvailableText' | translate}}
                    </mat-option>
                    <mat-option *ngFor="let sl of shippingLabels" [value]="sl?.procedureId">{{sl.description}}</mat-option>
                </mat-select>
                <mat-error>{{'selectPrintLabelView.shippingLabelRequiredText' | translate}}</mat-error>
            </mat-form-field>

        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button (click)="close()">{{'selectPrintLabelView.cancelButton' | translate}}</button>
        <button mat-raised-button color="primary" (click)="print()" [disabled]="form.invalid || printing">{{'selectPrintLabelView.printLabel' | translate}}</button>
    </mat-dialog-actions>
</div>
